var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-body" },
    _vm._l(_vm.tableData, function(row) {
      return _c("Row", {
        key: row.id,
        attrs: {
          config: _vm.config,
          "row-data": row,
          "clickable-rows": _vm.clickableRows
        },
        on: {
          "row-click": function(val) {
            return _vm.$emit("row-click", val)
          },
          "btn-click": function(val) {
            return _vm.$emit("btn-click", val)
          },
          "delete-row": function(val) {
            return _vm.$emit("delete-row", val)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }